// extracted by mini-css-extract-plugin
module.exports = {"sales-page":"index_sales-page__Y-X3n","course-catalog":"index_course-catalog__28Ad3","image":"index_image__3RP9F"};